import React, { Component } from 'react';
import BoxInfo from './BoxInfo';

class Info extends Component {
  render() {
    return (
      <section id="info">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-6">
              <h2 className="info_title mb-5">Sekilas Info</h2>
              <p className="info_desc">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aliquid culpa illo excepturi cum sed dolorum nisi doloribus expedita nihil alias quas numquam earum explicabo dolor doloremque necessitatibus blanditiis, a maiores!</p>
            </div>
            <BoxInfo data={this.props.data} />
          </div>
        </div>
      </section>
    )
  }
}

export default Info;



// WEBPACK FOOTER //
// ./src/components/Info.js